import styles from './action-history.module.scss'
import { observer } from 'mobx-react-lite'
import {
  TableContainer,
  TableHeader,
  TableBodyContainer,
  TableBodyLine,
  TableBodyLineProps,
  PaginationButtons
} from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { ActionHistoryTableSortProps, ActionHistoryTableStatus } from 'mobx-stores/utils/action-history-table-base/action-history-table-base.types'
import { ActionHistoryDTO } from 'models/action-history'
import { useGetScrollWidth } from 'hooks/custom-hooks'
import { actionHistoryTableCellWidth } from './action-history.utils'

const ActionHistoryTableComponent = () => {

  const {
    actionHistoryStore: {
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect,
      triggerSearch,
      statusTableHeader
    }
  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const {scrollX,handleScroll} = useGetScrollWidth()
  const getBodyLineCells = (
    actionHistory: ActionHistoryDTO
  ): TableBodyLineProps['cells'] => {
    const cells: any = [
      {
        // widthPercentage: 80,
        widthPx : actionHistoryTableCellWidth.TIME,
        children: (
          <>
            {new Date(actionHistory?.time).toLocaleString()}
          </>
        ),
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.TIME)
      },
      {
        // widthPercentage: 80,
        widthPx : actionHistoryTableCellWidth.USER_NAME,
        children: (
          <>
            {actionHistory?.userFullname}
          </>
        ),
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.USER_NAME)
      },
      {
        // widthPercentage: 80,
         widthPx : actionHistoryTableCellWidth.ACTION_TYPE,
        children: (
          <>
            {actionHistory?.actionType}
          </>
        ),
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.ACTION_TYPE)
      },
      {
        // widthPercentage: 80,
         widthPx : actionHistoryTableCellWidth.ENTITY_TITLE,
        children: (
          <>
            {actionHistory?.entityTitle}
          </>
        ),
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.ENTITY_TITLE)
      },
      {
        // widthPercentage: 80,
         widthPx : actionHistoryTableCellWidth.CHANGES,
        children: (
          <>
            {actionHistory?.changes.map(changes => {
              return (
                <span className={styles.badgeChanges}>{changes.changeType}</span>
              )
            })}
          </>
        ),
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.CHANGES)
      },
    ]

    return cells
  },

    tableColumns: any = [
      {
        label: 'PERIOD',
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.TIME),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.TIME),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.TIME
        ),
        periodFilterProps: {
          period: searchProps.orderDate,
          setPeriod: orderDate => onSearchPropsChange({ orderDate }),
          className: styles.customFilterComponent
        },
        widthPx : actionHistoryTableCellWidth.TIME
      },
      {
        label: 'USER',
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.USER_NAME),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.USER_NAME),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.USER_NAME
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.userFullname,
          onChange: (userFullname => onSearchPropsChange({ userFullname }))
        },
        widthPx : actionHistoryTableCellWidth.USER_NAME,
      },
      {
        label: 'ACTION TYPE',
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.ACTION_TYPE),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.ACTION_TYPE),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.ACTION_TYPE
        ),
        selectProps: {
          noneLabel: 'All',
          options: statusTableHeader,
          value: searchProps.actionType,
          onChange: (actionType: ActionHistoryTableStatus) => onSearchPropsChange({ actionType })
        },
        widthPx : actionHistoryTableCellWidth.ACTION_TYPE,
      },
      {
        label: 'ENTITY TYPE',
        // widthPx: productsTableWidths.sku,
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.ENTITY_TITLE),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.ENTITY_TITLE),
        setSortDirection: handleSortDirectionChange(ActionHistoryTableSortProps.ENTITY_TITLE),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.entityTitle,
          onChange: (entityTitle => onSearchPropsChange({ entityTitle }))
        },
        widthPx : actionHistoryTableCellWidth.ENTITY_TITLE,
      },
      {
        label: 'CHANGES',
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.CHANGES),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.CHANGES),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.CHANGES
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.changes,
          onChange: (changes => onSearchPropsChange({ changes }))
        },
        widthPx : actionHistoryTableCellWidth.CHANGES,
      }
    ]

  return (
    <TableContainer style={{overflowX: 'auto'}} className={styles.thinScroll} onScroll={handleScroll}>
      <TableHeader tableColumns={tableColumns} />
      <TableBodyContainer className={styles.tableBodyContainer}>
        {searchResults.map((actionHistory: ActionHistoryDTO) => {
          return (
            <TableBodyLine cells={getBodyLineCells(actionHistory)} />
          )
        })}
      </TableBodyContainer>
      <PaginationButtons
        alwaysShow
        {...paginationInfo}
        onPageSelect={onPageSelect}
        style={{width : scrollX}}
      />
    </TableContainer>
  )
},

  ActionHistoryTable = observer(ActionHistoryTableComponent)
export { ActionHistoryTable }
